import { Directive, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[arkAdminClass]'
})
export class AdminClassDirective {

  isAdmin:boolean = (JSON.stringify(localStorage.getItem('isAdmin')) == 'true'? true : false );

  //role 1 = admin
  constructor(private renderer: Renderer2, hostElement: ElementRef) {
    if(this.isAdmin) {
      renderer.addClass(hostElement.nativeElement, 'class-admin');
    }
  }

}